// @flow
import React from 'react';
import {
  compose,
  setDisplayName,
} from 'recompose';
import DomainIcon from './Icon';

const PureDomainPremiumIcon = ({
  theme,
}) => (
  <DomainIcon
    theme={theme}
    icon="star"
    fill={theme.palette.secondary}
    alt="premium"
  />
);

export const enhance = compose(
  setDisplayName('DomainPremiumIcon'),
);

export default enhance(PureDomainPremiumIcon);
